export default __webpack_public_path__ + "static/media/1819 knife block B top.2aab36e5.png";